import React from 'react'
import PropTypes from 'prop-types'
import ReactCSS from 'react-addons-css-transition-group'
import { amberA700, amberA400, lightBlue600, orangeA700 } from 'material-ui/styles/colors'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

const theme = getMuiTheme({
	palette: {
		primary1Color: orangeA700,
		primary2Color: amberA400,
		accent1Color: lightBlue600,
	},
	appBar: {
		color: amberA700,
	},
})

export default function App({ children, location }) {
	const transition = location.action === 'POP' ? 'reversePageSwap' : 'pageSwap'

	return (
		<MuiThemeProvider muiTheme={theme}>
			<ReactCSS
				component="div"
				transitionName={transition}
				transitionEnterTimeout={500}
				transitionLeaveTimeout={500}
			>
				{ React.cloneElement(children, { key: location.pathname }) }
			</ReactCSS>
		</MuiThemeProvider>
	)
}

App.propTypes = {
	children: PropTypes.node,
	location: PropTypes.shape({
		action: PropTypes.string,
	}),
}



// WEBPACK FOOTER //
// ./src/components/App.jsx